import React from 'react';
import { View } from 'react-native';

import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { Card, PrimaryButton, SecondaryButton } from '../../design/components';

import { createPickListDetailStyles } from './PickListDetail.styles';

// First picking step: print the tub sticker, or skip it.
const PickListStartCard = ({ onPrint, isSubmitting, disabled, onSkip }) => {
	const styles = useThemedStyles(createPickListDetailStyles);

	return (
		<Card tone="current" style={styles.card}>
			<Text style={styles.cardTitle}>Start picking</Text>
			<Text style={styles.cardText}>
				Print the tub sticker first (driver, date, machine), stick it on the tub, then pick.
			</Text>
			<View style={styles.buttonRow}>
				<PrimaryButton
					style={styles.flexButton}
					size="compact"
					label="Print tub sticker"
					icon="printer"
					onPress={onPrint}
					loading={isSubmitting}
					disabled={disabled}
				/>
				<SecondaryButton
					label="Skip"
					onPress={onSkip}
				/>
			</View>
		</Card>
	);
};

export default PickListStartCard;
